// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1J1kr","rootCenter":"LoadMoreObserver_rootCenter__2EZTk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3F99D"};